import { GET_MEDIA_FOLDER_CONTENT } from '../../constants';

const initialState = {
  data: [],
  loading: false,
  error: {},
};

export default function (state = initialState, { type, payload } = {}) {
  switch (type) {
    case GET_MEDIA_FOLDER_CONTENT.LOAD:
      return {
        ...state,
        loading: true,
      };
    case GET_MEDIA_FOLDER_CONTENT.SUCCESS:
      return {
        ...state,
        data: payload,
        loading: false,
      };
    case GET_MEDIA_FOLDER_CONTENT.FAIL:
      return {
        ...state,
        error: payload,
        loading: false,
      };
    default:
      return state;
  }
}
